(function(root, factory) {
  'use strict';

  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    if (!root.ATSMultiVariantInventory) {
      root.ATSMultiVariantInventory = api;
    }
    root.ATSMultiVariantInventory.init(root.jQuery, root);
  }
})(typeof window !== 'undefined' ? window : this, function() {
  'use strict';

  var MAX_SAFE_INTEGER = 9007199254740991;

  function parseUnsignedInteger(value) {
    var normalized = String(value == null ? '' : value).trim();
    var parsed;

    if (!/^\d+$/.test(normalized)) {
      return null;
    }

    parsed = parseInt(normalized, 10);
    return isFinite(parsed) && parsed <= MAX_SAFE_INTEGER ? parsed : null;
  }

  function parseInventory(value) {
    var normalized = String(value == null ? '' : value).trim();
    var parsed;

    if (!/^-?\d+$/.test(normalized)) {
      return null;
    }

    parsed = parseInt(normalized, 10);
    return isFinite(parsed) && Math.abs(parsed) <= MAX_SAFE_INTEGER ? parsed : null;
  }

  function normalizeVariantId(value) {
    var normalized = String(value == null ? '' : value).trim();
    return /^\d+$/.test(normalized) && normalized !== '0' ? normalized : null;
  }

  function aggregateRows(rows) {
    var byVariant = Object.create(null);
    var order = [];
    var invalid = null;

    rows.forEach(function(row) {
      var id = normalizeVariantId(row.id);
      var quantity = parseUnsignedInteger(row.quantity);

      if (!id || quantity === null) {
        invalid = invalid || row;
        return;
      }

      if (quantity === 0) {
        return;
      }

      if (!byVariant[id]) {
        byVariant[id] = {
          id: id,
          quantity: 0,
          inventoryQuantity: row.inventoryQuantity,
          inventoryManagement: row.inventoryManagement,
          inventoryPolicy: row.inventoryPolicy,
          title: row.title || '',
          sku: row.sku || ''
        };
        order.push(id);
      }

      if (byVariant[id].quantity > MAX_SAFE_INTEGER - quantity) {
        invalid = invalid || row;
        return;
      }

      byVariant[id].quantity += quantity;
    });

    return {
      error: invalid ? { type: 'invalid_quantity', row: invalid } : null,
      items: order.map(function(id) { return byVariant[id]; })
    };
  }

  function cartQuantitiesByVariant(cartItems) {
    var totals = Object.create(null);

    (cartItems || []).forEach(function(item) {
      var id = normalizeVariantId(item.variant_id != null ? item.variant_id : item.id);
      var quantity = parseUnsignedInteger(item.quantity);

      if (id && quantity !== null) {
        totals[id] = (totals[id] || 0) + quantity;
      }
    });

    return totals;
  }

  function isInventoryLimited(item) {
    var management = String(item.inventoryManagement == null ? '' : item.inventoryManagement).trim().toLowerCase();
    var policy = String(item.inventoryPolicy == null ? '' : item.inventoryPolicy).trim().toLowerCase();

    return management !== '' &&
      management !== 'null' &&
      management !== 'undefined' &&
      management !== 'false' &&
      policy === 'deny' &&
      parseInventory(item.inventoryQuantity) !== null;
  }

  function validateInventory(items, cartItems) {
    var existing = cartQuantitiesByVariant(cartItems);
    var failure = null;

    items.some(function(item) {
      var inventory;
      var resultingQuantity;

      if (!isInventoryLimited(item)) {
        return false;
      }

      inventory = parseInventory(item.inventoryQuantity);
      resultingQuantity = (existing[item.id] || 0) + item.quantity;

      if (resultingQuantity > inventory) {
        failure = {
          item: item,
          available: inventory,
          existing: existing[item.id] || 0,
          requested: item.quantity,
          resultingQuantity: resultingQuantity
        };
        return true;
      }

      return false;
    });

    return failure;
  }

  function shopifyRoot(shopify) {
    var path = shopify && shopify.routes && shopify.routes.root ? shopify.routes.root : '/';
    return path.charAt(path.length - 1) === '/' ? path : path + '/';
  }

  function isCartResponse(cart) {
    return !!cart && Array.isArray(cart.items) && cart.items.every(function(item) {
      return !!normalizeVariantId(item.variant_id != null ? item.variant_id : item.id) &&
        parseUnsignedInteger(item.quantity) !== null;
    });
  }

  function buildAddPayload(items) {
    return {
      items: items.map(function(item) {
        return { id: item.id, quantity: item.quantity };
      })
    };
  }

  function serverErrorMessage(xhr, fallback) {
    var response = xhr && xhr.responseJSON;
    var message;

    if (!response && xhr && xhr.responseText) {
      try {
        response = JSON.parse(xhr.responseText);
      } catch (ignore) {
        response = null;
      }
    }

    message = response && (response.description || response.message);
    return typeof message === 'string' && message.trim() ? message : fallback;
  }

  function variantLabel(item) {
    if (item.title && item.sku) {
      return item.title + ' — ' + item.sku;
    }
    return item.title || item.sku || '';
  }

  function inventoryFailureMessage(baseMessage, failure) {
    var label = variantLabel(failure.item);
    var maximumAdditional = Math.max(failure.available - failure.existing, 0);
    var message = String(baseMessage == null ? '' : baseMessage).trim();

    if (label) {
      message += ' for ' + label;
    }

    if (message && !/[.!?]$/.test(message)) {
      message += '.';
    }

    if (failure.existing > 0) {
      return message +
        ' Already in cart: ' + failure.existing + '.' +
        ' Requested now: ' + failure.requested + '.' +
        ' Available: ' + failure.available + '.' +
        ' Maximum additional quantity allowed: ' + maximumAdditional + '.';
    }

    return message +
      ' Requested: ' + failure.requested + '.' +
      ' Available: ' + failure.available + '.';
  }

  function setSubmitControl($form, submitting) {
    var $button = $form.find('[name="add"]:first');

    $button.each(function() {
      var $current = $form.constructor(this);

      if (submitting) {
        this.__atsMatrixWasDisabled = !!$current.prop('disabled');
        $current.prop('disabled', true).attr('aria-busy', 'true').addClass('disabled');
      } else {
        $current
          .prop('disabled', !!this.__atsMatrixWasDisabled)
          .removeAttr('aria-busy');
        if (!this.__atsMatrixWasDisabled) {
          $current.removeClass('disabled');
        }
        delete this.__atsMatrixWasDisabled;
      }
    });
  }

  function startSubmission($form) {
    if ($form.data('ats-matrix-submitting')) {
      return false;
    }

    $form.data('ats-matrix-submitting', true);
    setSubmitControl($form, true);
    return true;
  }

  function finishSubmission($form) {
    $form.removeData('ats-matrix-submitting');
    setSubmitControl($form, false);
  }

  function stabilizeSubmitControls($form) {
    var $original;
    var $copy;

    if (!$form || !$form.length) {
      return;
    }

    $form.addClass('ats-matrix-stable-submit');
    $original = $form.find('#addToCart').first();
    $copy = $form.find('#addToCartCopy');

    if ($original.length) {
      $original
        .removeClass('hide-cart-button')
        .attr('type', 'submit')
        .removeAttr('aria-hidden');
    }

    if ($copy.length) {
      $copy
        .prop('disabled', true)
        .attr('aria-hidden', 'true');
    }
  }

  function init($, browser) {
    if (!$ || !browser || browser.__atsMultiVariantInventoryInitialized) {
      return;
    }

    browser.__atsMultiVariantInventoryInitialized = true;

    function readRows($matrix) {
      var rows = [];

      $matrix.find('.variant-checkboxes:checked').each(function() {
        var $row = $(this).closest('[data-variant-id]');
        rows.push({
          id: $row.attr('data-variant-id'),
          quantity: $row.find('.qty-area .quantity').first().val(),
          inventoryQuantity: $row.attr('data-inventory-quantity'),
          inventoryManagement: $row.attr('data-inventory-management'),
          inventoryPolicy: $row.attr('data-inventory-policy'),
          title: $row.attr('data-variant-title'),
          sku: $row.attr('data-sku')
        });
      });

      return rows;
    }

    function updateLinePrice() {
      var $input = $(this);
      var price = $input.closest('li').find('.variant-price').data('variant-price');
      var quantity = parseUnsignedInteger($input.val());
      var newPrice;

      if (quantity === null || typeof browser.Shopify === 'undefined' || typeof browser.Shopify.formatMoney !== 'function') {
        return;
      }

      newPrice = browser.Shopify.formatMoney(price * quantity, '{{amount}}');
      $input.closest('li').find('.variant-price').html('<span itemprop="price" class="money">' + newPrice + '</span>');
    }

    function refreshCartAfterFailure(rootPath, callback) {
      $.ajax({
        url: rootPath + 'cart.js',
        dataType: 'json',
        type: 'get',
        cache: false,
        timeout: 10000
      }).always(callback);
    }

    function addItems($form, items, rootPath, fallbackMessage) {
      $.ajax({
        url: rootPath + 'cart/add.js',
        dataType: 'json',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(buildAddPayload(items)),
        timeout: 15000
      }).done(function() {
        finishSubmission($form);
        browser.location = rootPath + 'cart';
      }).fail(function(xhr) {
        var message = serverErrorMessage(xhr, fallbackMessage);

        refreshCartAfterFailure(rootPath, function() {
          finishSubmission($form);
          browser.alert(message);
        });
      });
    }

    function submitMatrix($form, $matrix) {
      var collection;
      var rootPath;
      var inventoryMessage;
      var quantityMessage;
      var addMessage;

      collection = aggregateRows(readRows($matrix));
      inventoryMessage = $matrix.attr('data-inventory-error-message');
      quantityMessage = $matrix.attr('data-quantity-error-message');
      addMessage = $matrix.attr('data-add-error-message');

      if (collection.error) {
        browser.alert(quantityMessage + (variantLabel(collection.error.row) ? ': ' + variantLabel(collection.error.row) : ''));
        return;
      }

      if (!collection.items.length) {
        return;
      }

      if (!startSubmission($form)) {
        return;
      }

      rootPath = shopifyRoot(browser.Shopify);

      $.ajax({
        url: rootPath + 'cart.js',
        dataType: 'json',
        type: 'get',
        cache: false,
        timeout: 10000
      }).done(function(cart) {
        var failure;

        if (!isCartResponse(cart)) {
          addItems($form, collection.items, rootPath, addMessage);
          return;
        }

        failure = validateInventory(collection.items, cart.items);

        if (failure) {
          finishSubmission($form);
          browser.alert(inventoryFailureMessage(inventoryMessage, failure));
          return;
        }

        addItems($form, collection.items, rootPath, addMessage);
      }).fail(function() {
        // Shopify's add response remains authoritative if cart prevalidation is unavailable.
        addItems($form, collection.items, rootPath, addMessage);
      });
    }

    function initializeMatrix(element) {
      var $matrix = $(element);
      var $form = $matrix.closest('form');
      var $matrices;

      if (!$form.length || $form.data('ats-matrix-handler-initialized')) {
        return;
      }

      stabilizeSubmitControls($form);
      $form.data('ats-matrix-handler-initialized', true);
      $matrices = $form.find('.ats-variant-matrix');

      $matrices.find('.qty-area .quantity')
        .each(updateLinePrice)
        .on('change.atsVariantInventory', updateLinePrice);

      $matrices.on('change.atsVariantInventory', '.variant-checkboxes', function() {
        $(this).closest('li').toggleClass('active', $(this).prop('checked'));
      });

      $form.on('submit.atsVariantInventory', function(event) {
        event.preventDefault();
        submitMatrix($form, $matrices);
      });
    }

    $(function() {
      $('.ats-variant-matrix').each(function() {
        initializeMatrix(this);
      });
    });
  }

  return {
    aggregateRows: aggregateRows,
    buildAddPayload: buildAddPayload,
    cartQuantitiesByVariant: cartQuantitiesByVariant,
    finishSubmission: finishSubmission,
    isInventoryLimited: isInventoryLimited,
    isCartResponse: isCartResponse,
    inventoryFailureMessage: inventoryFailureMessage,
    normalizeVariantId: normalizeVariantId,
    parseInventory: parseInventory,
    parseUnsignedInteger: parseUnsignedInteger,
    serverErrorMessage: serverErrorMessage,
    shopifyRoot: shopifyRoot,
    stabilizeSubmitControls: stabilizeSubmitControls,
    startSubmission: startSubmission,
    validateInventory: validateInventory,
    variantLabel: variantLabel,
    init: init
  };
});
